{
  "pt": {
    "ticket": {
      "actions": {
        "assignCustomer": "Procedimento completo",
        "bulk_assign_new_emp": "Atribuir novos responsáveis em massa",
        "close": "Fechar",
        "create_new": "Criar nova conversa",
        "customer_new_ticket": "Nova conversa",
        "delete": "Eliminar",
        "edit": "Editar",
        "goToConversation": "Ir para a conversa",
        "move_to_existing": "Mover mensagem para uma conversa existente",
        "new": "Nova conversa",
        "reopen": "Reabrir",
        "selectResponsible": "Selecionar responsável",
        "selectUnit": "Selecionar unidade",
        "show": "Mostrar",
        "startNew": "Iniciar uma nova conversa"
      },
      "attributes": {
        "status": "Estado",
        "statuses": {
          "closed": "Fechado",
          "feedback": "Aguardar reacções",
          "ongoing": "Em curso",
          "open": "Aberto"
        },
        "title": "Título"
      },
      "editor": {
        "tooltips": {
          "bold": "Negrito",
          "bulletList": "Lista de marcadores",
          "highlight": "Destaque",
          "italic": "Itálico",
          "link": "Ligação",
          "orderedList": "Lista numerada",
          "redo": "Refazer",
          "strike": "Riscado",
          "textColor": "Cor do texto",
          "underline": "Sublinhar",
          "undo": "Anular",
          "unlink": "Desvincular"
        }
      },
      "labels": {
        "additionalQuestion": "Tem mais alguma pergunta?",
        "all": "Todos",
        "allProjects": "Todos os projectos",
        "allUnits": "Todas as unidades",
        "assign_conversations": "Atribuir conversas de",
        "bulk_assign_new_emp_warning": "Esta atualização incluirá também as conversas relacionadas com decisões ou cuidados posteriores. Para as decisões relacionadas (destas conversas afectadas), o funcionário responsável também será atualizado.",
        "cantChangeResponsibleAftercare": "Esta conversa está associada a um ticket de acompanhamento. Por favor, altere o responsável lá.",
        "cantChangeResponsibleDecision": "Esta conversa está associada a uma decisão. Por favor, altere o responsável lá.",
        "cantDelete": "Esta conversa pertence a uma decisão e não pode ser apagada.",
        "cantEdit": "Esta conversa pertence a uma decisão. Edite-a antes a partir da decisão",
        "changeResponsible": "Alterar",
        "change_responsible": "Mudar o responsável pelas conversas",
        "clientWillRespondSoon": "Entraremos em contacto consigo o mais rapidamente possível",
        "contact": "Contacto",
        "contactPerson": "A sua pessoa de contacto",
        "contactPersonWithName": "O seu contacto {name} ",
        "conversation_title": "Título da conversa",
        "conversations": "Conversas",
        "create_ticket": "Criar uma conversa",
        "customer": "Cliente",
        "customers": "Clientes",
        "decision": "Que decisão?",
        "decisionConversation": "Decisão",
        "decisionConversations": "Decisões",
        "disabled_unit": "Esta unidade foi desativada. Não é possível enviar mensagens.",
        "documentAddedBy": "de",
        "documents": "Documentos",
        "email_forwarding": "Reencaminhamento de correio eletrónico",
        "employee": "Empregado",
        "export_conversation": "Exportar conversa",
        "files": "Ficheiros",
        "filter": "Filtro",
        "inbound_by": "Entrada por {name}",
        "inbound_emails": "Correio eletrónico de entrada",
        "info": "Tem uma pergunta e não encontrou a resposta na secção {faq_route}? Faça-a aqui! Tente agrupar as suas perguntas em tópicos de conversação claros, por exemplo, \"Cozinha\". ",
        "keywords": "Pesquisar conteúdo",
        "lastMessage": "Última mensagem",
        "message": "Mensagem",
        "message_placeholder": "Escreva aqui a sua mensagem...",
        "message_subtitle": "Descreva a sua questão ou problema",
        "messaged_at_nulls_first_asc": "Atividade mais antiga",
        "messaged_at_nulls_last_desc": "Última atividade",
        "myProjects": "Os meus projectos",
        "myTickets": "As minhas conversas",
        "name_lower_asc": "Título A -> Z",
        "name_lower_desc": "Título Z -> A",
        "newConversation": "Nova conversa",
        "newMessage": "Nova mensagem",
        "newMessages": "Novas mensagens",
        "newWithPartner": "Ziggu e {partner}",
        "newWithZiggu": "Apenas Ziggu",
        "noCustomer": "Nenhum cliente atribuído ou convidado ainda",
        "noCustomerAssignedToUnit": "Nenhum cliente atribuído a esta unidade. Deseja continuar?",
        "noCustomerAssignedToUnitExplainer": "Note que, por conseguinte, terá de selecionar outro destinatário.",
        "noCustomerAssignedToUnit_SUP": "Nenhum cliente atribuído a este projeto. Deseja continuar?",
        "noCustomerInvited": "O cliente atribuído a esta unidade ainda não foi convidado. Deseja continuar?",
        "noFiles": "Ainda não foram carregados ficheiros",
        "noMessagesYet": "Ainda não há mensagens",
        "noTickets": "Sem conversas",
        "no_messages": "A conversa não tem mensagens",
        "notSeenYet": "Ainda não visto",
        "notYetDetermined": "Ainda não determinado",
        "note": "Nota",
        "note_placeholder": "Escreva apenas aos membros da equipa. Digite {'@'} para mencionar um membro da equipa e ele será notificado.",
        "onlySelect": "Mostrar apenas",
        "orNewTicket": "Ou abrir uma nova sobre um tema diferente",
        "otherTickets": "Outras conversas",
        "participants": "1 participante | {count} participantes",
        "partner": "Parceiro",
        "partnerGroup": "Com quem quer falar?",
        "partnersDecision": "Parceiros de decisão",
        "pendingContactPerson": "A sua pessoa de contacto responderá o mais rapidamente possível",
        "pendingTickets": "Novas mensagens",
        "project": "Projeto",
        "read": "Ler",
        "remove_inbound_email": "Remover {email}?",
        "reply": "Responder",
        "reply_placeholder": "Escrever a toda a gente",
        "responsible": "Responsável",
        "search": "Pesquisar",
        "search_conversation": "Pesquisar",
        "seen": "Visto",
        "seenAll": "todos",
        "seenBy": "Visto por {name}",
        "selectLevel": "Selecionar nível",
        "selectUnit": "Selecionar unidade",
        "show": "Exibição",
        "showFiles": "Mostrar ficheiros",
        "showTicketsFor": "Mostrar conversas para",
        "showingAll": "Todas as conversas",
        "sort": "Ordenar por",
        "startConversation": "Iniciar uma nova conversa",
        "startConversationForProject": "Iniciar uma nova conversa no projeto ",
        "startNewConversation": "Iniciar uma nova conversa",
        "subject": "Assunto",
        "subject_subtitle": "Descreva em poucas palavras",
        "teamMember": "Membro da equipa",
        "ticketClosed": "Esta conversa foi encerrada.",
        "ticketClosedByResponsible": "Esta conversa foi encerrada por {responsible}",
        "ticketClosedCustomer": "Se tiver uma pergunta diferente, abra uma nova conversa.",
        "ticketClosedEmployee": "Se pretender reabrir a conversa, altere o estado acima.",
        "ticket_category": "Categoria",
        "tickets_all_projects": "Conversas todos os projectos",
        "to": "para",
        "unit": "Unidade",
        "unit_name_lower_asc": "Unidade A -> Z",
        "unit_name_lower_desc": "Unidade Z -> A",
        "unread": "Não lido",
        "upload_files": "1 ficheiro pendente | {count} ficheiros pendentes",
        "warning_move_message_to_new_ticket": "Esta mensagem será movida para uma conversa regular, que não estará vinculada a uma decisão ou problema.",
        "withMentions": "Mencionado em",
        "withMessages": "Com mensagens",
        "writeMessageToBecomeResponsible": "Escrever uma mensagem para se tornar responsável",
        "you": "Você"
      },
      "messages": {
        "redirect_decision": "Esta conversa faz parte de uma decisão. Clique aqui para ver a decisão:",
        "redirect_issue": "Esta conversa faz parte de um problema. Clique aqui para ver o problema:",
        "redirect_link": "Ver detalhes"
      },
      "navigation": {
        "backToTickets": "Voltar às conversas"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Tente agrupar as suas perguntas em tópicos gerais de conversação, por exemplo, \"Cozinha\".",
            "title": "Uma pergunta? Faça-a aqui!"
          },
          "none": {
            "title": "Não foram encontradas conversas"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Inicie a sua primeira conversa com alguém!",
            "title": "Alguma coisa para perguntar?"
          },
          "none": {
            "subtitle": "Ajuste os filtros na parte superior da página ou comece a seguir um projeto para encontrar as conversas relacionadas",
            "subtitle_aftercare": "Clique nos 3 pontos de um obstáculo para iniciar uma conversa",
            "title": "Não foram encontradas conversas"
          }
        }
      },
      "toasts": {
        "responsible_updated": "Responsável atualizado com sucesso!"
      },
      "validation": {
        "mustBeMaximum": "O nome deve ter menos de {number} caracteres.",
        "needCustomer": "Selecionar um cliente",
        "needMessage": "Mensagem necessária",
        "needName": "Título necessário",
        "needResponsible": "Selecionar um responsável",
        "needSubject": "Assunto requerido",
        "needUnit": "Selecionar uma unidade"
      }
    }
  }
}
